import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconInfoFilled = () => {
  return (
    <g>
      <path
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm.775 6.632c-.081-.613-.868-.877-1.302-.39L5.94 7.963l-.067.088a.746.746 0 0 0 .13.967l.088.067c.305.2.72.15.969-.13l.224-.252.001 4.498.007.106c.082.613.868.877 1.302.39l1.567-1.756.068-.088a.746.746 0 0 0-.129-.967l-.088-.067a.75.75 0 0 0-.97.128l-.26.29.001-4.5zm-.742-4.181a.748.748 0 0 0-.749.747v1.05l.007.102a.749.749 0 0 0 1.491-.101V3.198l-.007-.101a.749.749 0 0 0-.742-.646z"
        
      />
    </g>
  );
};

export default withIcon(IconInfoFilled);
